import 'bootstrap';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { usePlayerStore } from "./storage/storePlayer";
import videoLayout from './sections/video-layout.vue';
import { defineRule, configure } from 'vee-validate'

import {
    required,
    numeric,
} from '@vee-validate/rules'

defineRule('required', required)
defineRule('numeric', numeric)


const videoContainer = document.querySelector('#videoPlayerContainer');
const currentLangVideo = videoContainer.dataset.lang;

// Create Vue 3 app
const app = createApp({
    name: 'videoPlayerRoot',
    components: {
        videoLayout
    },
    setup() {
        // You can use Pinia store here if needed
        const store = usePlayerStore();
        return {
            store
        };
    }
});

// Create and use Pinia
const pinia = createPinia();
app.use(pinia);

// Mount the app
const videoPlayer = app.mount('#videoPlayerContainer');

// Update event handlers to use Pinia store
if (jsEnabled == 1) {
    window.addEventListener('message', function (msgEvt) {
        try {
            const eventData = JSON.parse(msgEvt.data);
            const store = usePlayerStore();
            if (eventData.event === 'stopVideo' && store.getPlayer) {
                store.getPlayer.pause();
            }
        } catch (e) {
            return false;
        }
    });
}

window.closeLightbox = function (type) {
    $('#bottom-button-bar').css({ opacity: 1, bottom: -1, transition: '0.3s' });

    const store = usePlayerStore();
    store.addActiveHotspot(null);
    if (type == 'play') {
        store.getPlayer.play();
    }
};
